export default __webpack_public_path__ + "static/media/refresh.bba6cee9.svg";